import 'react-datepicker/dist/react-datepicker.css'

import TableProtocolBook from '../../components/table/files/TableProtocolBook'

function ProtocolBook() {
  return <TableProtocolBook />
}

export default ProtocolBook
